<template>
  <div>
    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menuIndex: '/order/nocontract/own/tobe',
      menu: [
        {
          name: "待接单",
          path: '/order/nocontract/own/tobe',
        },
        {
          name: "运送中",
          path: '/order/nocontract/own/ing',
        },
        {
          name: "已送达",
          path: '/order/nocontract/own/arrive',
        },
        {
          name: "待审核",
          path: '/order/nocontract/own/uncheck',
        },
        {
          name: "已完成",
          path: '/order/nocontract/own/done',
        },
      ],
    };
  },
  methods: {},
  watch: {
    $route() {
      this.menuIndex = this.$route.path
    },
  },
  mounted() {
    console.log(this.$route.path)
    this.menuIndex = this.$route.path
  },
};
</script>
